<template>
    <div>
        <div class="type_container">
            <div class="w-full md:w-5/12 flex mt-0 gap-4 justify-start">
                <label for="senderSelf" class="radio-label">
                    <input class=" bg-primary-yellow text-secondary-yellow" name="sendertype" type="radio"
                        id="senderSelf" value="self" v-model="sender.type" />
                    Self
                    <span></span>
                </label>

                <label for="senderOthers" class="radio-label">
                    <input type="radio" v-model="sender.type" value="others" id="senderOthers" name="sendertype" />
                    Others
                    <span></span>
                </label>
            </div>

            <div>
                <div class=" pb-0 mt-0 flex items-center flex-wrap">
                    <base-checkbox v-model="sender.useCurrentLocation" label="Use My Current Location" />
                    <span class="mx-3"></span>
                    <base-checkbox v-if="sender.type != 'self'" v-model="sender.useExistingSender"
                        label="Use existing sender" />
                </div>
            </div>
        </div>


        <div class="flex flex-wrap justify-start">
            <div v-if="sender.useExistingSender" class="slice-option">
                <label class="label">Name</label>
                <el-select filterable v-model="sender.nameSelect" placeholder="-- Select --">
                    <el-option v-for="location in PrevLocations" :key="location.id" :label="location.contactName"
                        :value="location.id">
                    </el-option>
                </el-select>
            </div>
            <div v-if="!sender.useExistingSender" class="slice-option">
                <label class="label">Name</label>
                <input type="text" class="input-mini" placeholder="--Enter--" v-model="sender.contactName" />
            </div>

            <div class="slice-option">
                <label class="label">Email</label>
                <input :disabled="sender.type === 'self'" type="text" class="input-mini" placeholder="--Enter--" v-model="sender.email"
                :class="[ sender.type === 'self' ? ' cursor-not-allowed' : '']"
                />
                <span v-if="!isEmailValid && sender.email != ''" class="mt-2 text-red-500 inline-block">Email is
                    invalid</span>
            </div>


            <div class="slice-option_phone">
                <div class="flex justify-between items-center">
                    <label class="label whitespace-no-wrap">Phone Number</label>
                    <div class="w-full flex mt-1 gap-4 justify-end">
                        <label for="mobilePhone" class="radio-label">
                            <input class=" bg-primary-yellow text-secondary-yellow" name="phone" type="radio"
                                id="mobilePhone" value="mobile" v-model="sender.mobileNumberType" />
                            Mobile
                            <span></span>
                        </label>

                        <label for="fixedPhone" class="radio-label">
                            <input type="radio" v-model="sender.mobileNumberType" value="fixed" id="fixedPhone"
                                name="phone" />
                            Fixed
                            <span></span>
                        </label>
                    </div>
                </div>
                <vue-tel-input :preferredCountries="['Ng']" v-model="sender.mobile" class="phone_input_style"></vue-tel-input>
                <span v-if="isPhoneNumberInValid" class="mt-2 text-red-500 inline-block">Phone number is invalid</span>
            </div>

            <div class="slice-option_address">
                <div class="flex justify-between items-center">
                    <label class="label whitespace-no-wrap">Pick Up Address <abbr class="address_grey">(Unit, House
                            Number, Street, City, State)</abbr> </label>
                    <div class="w-full flex mt-1 gap-4 justify-end">
                        <label for="firstAddress" class="radio-label">
                            <input class=" bg-primary-yellow text-secondary-yellow" name="address" type="radio"
                                id="firstAddress" value="residential" v-model="sender.customerType" />
                            Residential
                            <span></span>
                        </label>

                        <label for="lastAddress" class="radio-label">
                            <input type="radio" v-model="sender.customerType" value="business" id="lastAddress"
                                name="address" />
                            Business{{ JSON.stringify(senderAddrrDisable) }}
                            <span></span>
                        </label>
                    </div>
                </div>
                <input :disabled="senderAddrrDisable" v-model="addressInput" type="text" class="input-mini"
                    placeholder="--Enter--" :class="[senderAddrrDisable && 'cursor-not-allowed']" />
                <span v-if="sender.address?.name && addressInput != ''" class="google_pick_location">
                    <img src="/icons/location_icon.svg" class="image_loc" />
                    {{ selectedAddress ? selectedAddress.name : "" }}</span>
            </div>
            <div class="slice-option_picker">
                <div class="flex justify-between items-center flex-wrap w-full">
                    <label class="label">Preferred Pickup Date</label>
                    <el-date-picker placeholder="Select" class="full_width full_width_sender"
                        v-model="sender.pickUpDays" :picker-options="{
                            disabledDate: (time) => disabledEndDate(time, null),
                        }"></el-date-picker>
                </div>
            </div>

            <div class="slice-option_picker">
                <div class="flex justify-between items-center flex-wrap w-full">
                    <label class="label">Preferred Pickup Time Range<span class="opacity-50"> (optional)</span></label>
                    <div class="flex  w-full justify-between items-center">
                        <!-- <div class="clock_box">
                            <img src="./icons//clock.svg"/>
                        </div> -->
                        <el-time-picker class="full_width full_width_sender mr-2 only_hour_picker"
                            placeholder="Start time" v-model="startTime" :disabled-seconds="true" format="hh:mm"
                            value-format="hh A" popper-class="only_hour_picker">
                        </el-time-picker>
                        <el-time-picker class="full_width full_width_sender" placeholder="End time" v-model="endTime"
                            popper-class="only_hour_picker" :disabled-seconds="true" format="hh:mm" value-format="hh A">
                        </el-time-picker>
                    </div>
                </div>
            </div>


        </div>


        <div class="w-full pb-10 mt-3">
            <base-checkbox v-model="sender.sendShippingUpdates"
                label="Send me status updates regarding my shipment with the email provided." />
        </div>
    </div>
</template>

<script>
import moment from 'moment'

export default {
    name: 'Sender',
    computed: {
        currentLocation() {
            return this.$store.getters.currentLocation;
        },
        senderAddrrDisable() {
            const method = this.$store.getters.getNewBookingShippingMethod
            return (method === 'terminal-to-terminal' || method === 'terminal-to-door') && this.$_3pl
        },
        canSend() {
            const { contactName, email, mobile, pickUpDays, address } = this.sender
            return (!this.isPhoneNumberInValid && this.isEmailValid && contactName && email != "" && mobile != "" && pickUpDays && address?.lat)
        },
        isPhoneNumberInValid() {
            let trimTel = (this.sender?.mobile || "").replace(/ /g, "")
            return (this.sender.mobile != "" && trimTel.length < 11) || (this.sender.mobile != "" && trimTel.length > 11)
        },
        isEmailValid() {
            const emailRegex =
                /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailRegex.test(this.sender.email);
        },
        customStyle() {
            return {
                width: '100%',
                padding: '7px 10px',
                borderRadius: '5px',
                border: '1px solid rgb(183 189 205)'
            }
        },
        payload() {
            return {
                userId: this.$store.getters.userId,
                type: "takeOff",
            };
        },
    },
    data() {
        return {
            PrevLocations: [],
            addressInput: "",
            selectedAddress: {},
            startTime: '',
            endTime: '',
            addressDebounce: null,
            latitude: "",
            longitude: "",
            PlAddress: "",
            customerAddress: "",
            sender: {
                type: 'others',
                useCurrentLocation: false,
                useExistingSender: false,
                contactName: '',
                email: '',
                mobileNumberType: 'mobile',
                customerType: 'residential',
                address: {},
                mobile: '',
                pickUpDays: new Date(),
                sendShippingUpdates: false,
                nameSelect: '',
                pickUpTime: [],
            }
        }
    },
    watch: {
        currentLocation() {
            if (!this.$_3pl) return;
            this.PlAddress = `${this.$store.getters?.currentLocation?.location?.address}, ${this.$store.getters?.currentLocation?.location?.city}, ${this.$store.getters?.currentLocation?.location?.state}`;
            this.addressInput = this.$_3pl ? this.PlAddress : ""
        },
        addressInput: {
            handler(val) {
                clearTimeout(this.addressDebounce); // 🧹 Clear previous timer
                if (val?.trim().length > 3) {
                    // 🕒 Wait 500ms before calling getCloseLocation
                    this.addressDebounce = setTimeout(() => {
                        this.getCloseLocation(val);
                    }, 500);
                }
            },
            immediate: false,
        },
        "sender.type"() {
            if (this.sender.type === 'self') {
                let userInfo = {
                    contactName: `${this.$store.getters.user.firstname} ${this.$store.getters.user.lastname}`,
                    email: this.$store.getters.user.email,
                    mobile: this.$store.getters.user?.mobile_no || "",
                    pickUpDays: new Date(),
                    // address: {
                    //     name: this.$store?.getters?.user?.address || this.$store?.getters?.user?.address?.name
                    // }
                }
                this.addressInput = this.$_3pl ? this.PlAddress : this.customerAddress
                this.sender = { ...this.sender, ...userInfo }
            } else {
                this.sender = {
                    type: 'others',
                    useCurrentLocation: false,
                    useExistingSender: false,
                    contactName: '',
                    email: '',
                    id: undefined,
                    mobileNumberType: 'mobile',
                    customerType: 'residential',
                    address: {},
                    mobile: '',
                    pickUpDays: null,
                    sendShippingUpdates: false,
                    nameSelect: '',
                    pickUpTime: [],
                }
                this.addressInput = this.$_3pl ? this.PlAddress : ""
            }
        },
        "sender.useExistingSender"(val) {
            if (!val) {
                let userInfo = {
                    contactName: ``,
                    email: "",
                    mobile: "",
                    address: {
                        name: "",
                        lat: undefined,
                        lng: undefined
                    }
                }
                this.sender = { ...this.sender, ...userInfo }
            }
        },
        "sender.nameSelect"() {
            let selectedLocation = this.PrevLocations.find(location => location.id === this.sender.nameSelect);
            let userInfo = {
                contactName: `${selectedLocation.contactName}`,
                email: selectedLocation?.email,
                mobile: selectedLocation?.mobile || "",
                address: {
                    name: selectedLocation?.address?.name,
                    lat: selectedLocation?.address?.lat,
                    lng: selectedLocation?.address?.lng,
                    state: selectedLocation?.address?.state
                }
            }
            this.addressInput = selectedLocation?.address?.name || ""
            this.sender = { ...this.sender, ...userInfo }
        },
        "sender.useCurrentLocation"(val) {
            if (val) {
                this.getUserLocation()
            }
        }
    },
    mounted() {
        this.getAllLocations();
        this.checkAutoloadInfo();
        this.PlAddress = `${this.$store.getters?.currentLocation?.location?.address}, ${this.$store.getters?.currentLocation?.location?.city}, ${this.$store.getters?.currentLocation?.location?.state}`;
        this.customerAddress = this.$store?.getters?.user?.address || this.$store?.getters?.user?.address?.name;
        this.addressInput = this.$_3pl ? this.PlAddress : ""
    },
    methods: {
        getUserLocation() {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(
                    (position) => {
                        this.latitude = position.coords.latitude;
                        this.longitude = position.coords.longitude;
                        this.getAddressInfo({ lat: this.latitude, long: this.longitude })
                    },
                );
            } else {
                this.generateToast("Geolocation is not supported by this browser.", "error");
            }
        },
        async getAddressInfo(payload) {
            try {
                const res = await this.$_getStateNameWithDim(payload);
                this.addressInput = res.data.address
            } catch (error) {
                // code here
            }
        },
        checkAutoloadInfo() {
            const prevSender = this.$store.getters.latestNewPrevShipper;
            if (this.$store.getters.latestNewShippingForSelf) {
                this.sender.type = "self";
            } else {
                this.sender.type = "others";
                this.sender.address = prevSender?.address;
                this.sender.email = prevSender?.email;
                this.sender.mobile = (prevSender?.mobile || "");
                this.sender.contactName = prevSender?.contactName;
                this.addressInput = prevSender?.address?.name
            }
        },
        async getCloseLocation(val) {
            const res = await this.$_searchAddress({ query: val?.trim() })
            this.selectedAddress = res.data.results[0];
            this.sender.address = { ...res.data.results[0], name: this.addressInput };
        },
        async getAllLocations() {
            try {
                const response = await this.$_getAllBookingLocations(this.payload);
                this.PrevLocations = response.data.data.locations;
            } catch (error) {
                this.handleError(error);
            }
        },
        saveSenderTostore() {
            if (!this.canSend && !this.sender.pickUpDays) {
                this.generateToast("Sender PickUp Date not Seleceted");
                return false
            }
            else if (!this.canSend && !this.sender.address?.lat) {
                this.generateToast("Pick up address must be valid");
                return false
            }
            else if (!this.canSend && !this.sender.pickUpDays) {
                this.generateToast("Sender Info not saved, invalid input", "error");
                this.sender.mobile = this.sender?.mobile || "--input-mobile--";
                this.sender.email = this.sender.email || "--input-email--"
                return false
            }
            else if (!this.canSend) {
                this.generateToast("Please fill all the required Sender fields to proceed", "error");
                return false
            }
            const starttime = this.startTime ? moment(this.startTime, 'h A').format('HH:mm') : undefined;
            const endtime = this.endTime ? moment(this.endTime, 'h A').format('HH:mm') : undefined;
            let pickUpTime = starttime && endtime ? [starttime, endtime] : [];
            let sender = { ...this.sender, pickUpDays: moment(this.sender.pickUpDays).format('YYYY-MM-DD'), pickUpTime };
            this.$store.dispatch('setSavedNewSender', sender)
            return true
        },
        disabledEndDate(date, departureDate) {
            // If departureDate then return valid dates after departureDate
            if (departureDate) {
                return date.getTime() < departureDate;
            } else {
                // If !departureDate then return valid dates after today
                return date.getTime() < Date.now() - 8.64e7;
            }
        },
        viewLocationDetails(response) {
            const addressData = {
                name: response.formatted_address,
                lat: response.geometry.location.lat(),
                lng: response.geometry.location.lng(),
                state: response?.address_components?.find(component => component.types.includes("administrative_area_level_1"))?.long_name || ""
            }
            this.sender.address = addressData
        },
    },
}
</script>

<style lang="scss" scoped>
.type_container {
    @apply flex items-center justify-between flex-wrap w-full
}

.clock_box {
    @apply flex items-center h-full px-2 bg-black-default
}

.address_grey {
    @apply opacity-50
}

.google_pick_location {
    @apply mt-2 inline-flex ml-2 text-sm items-center opacity-60;

    img {
        @apply mr-1
    }
}

.image_loc {
    @apply mr-2 w-[17px] opacity-50 mt-[2px]
}

.radio-label span::after {
    @apply bg-secondary-yellow
}

.text-header {
    font-size: 24px;
    font-weight: 500;
    @apply py-4;
}

.slice-option {
    @apply mt-4 sm:mt-7 sm:w-[48%] lg:w-[32%] w-full mr-[2%] lg:mr-[1.333%];
}

.slice-option_address {
    @apply mt-4 w-full;
}

.slice-option_picker {
    @apply mt-4 sm:mt-8 sm:w-[48%] lg:w-[32%] w-full mr-[2%] lg:mr-[1.333%];
}

.input-mini {
    @apply w-full py-2 px-2 border-[1px] border-primary-palegrey rounded-md bg-primary-lightblue;
}


.slice-option_phone {
    @apply mt-4 sm:mt-6 lg:mt-6 sm:w-[48%] lg:w-[32%] w-full mr-[2%] lg:mr-[1.333%];
}

.label {
    @apply w-full block whitespace-nowrap;
}

.full_width {
    width: 100%;
    @apply bg-primary-lightgrey;
}
</style>